import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { JobPortalService } from 'src/app/services/job-portal.service';

@Component({
  selector: 'app-asset-audit-report',
  templateUrl: './asset-audit-report.component.html',
  styleUrls: ['./asset-audit-report.component.css']
})
export class AssetAuditReportComponent implements OnInit {

  assetAuditReportList:any = [];

  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  isLoading: any = false
  id: any

  assetAuditReportForm: any | FormGroup
  cid:any
  formSubmit: boolean = false;


  locationUpdateForm: any | FormGroup
  isEdit: boolean = false
  singleAssetAuditReportData: any = [];
  fileName: any = ""
  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  searchFilter: any = ""
  recordName: any = ""
  recordId: any = ""
  file: any

  constructor(private generic_service: GenericService,
    private job_portal_service: JobPortalService,private fb: FormBuilder,private toastr: ToastrService) { }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.cid = Number(sessionStorage.getItem('cid'))
    this.assetAuditReportForm = this.fb.group({
      description: [''],
      financialYear: ['',[Validators.required]],
      auditReportDocumentName: ['',[Validators.required]],
      auditReportDocumentPath: ['',[Validators.required]],
      auditedByCompany: ['',[Validators.required]],
      auditReportSubmittedOn: [''],
    })
    this.getAllAssetAuditReport();
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page+1;
  }

  getAllAssetAuditReport(){
    this.isLoading = true

    this.generic_service.getAllAssetAuditReport().subscribe(
      (res:any)=> {
        console.log(res)
        this.assetAuditReportList = res.response
        this.totalRecords = res.response.length
        this.isLoading = false

      },
      (err:any)=>{
        console.log(err)
      }
    )
  }

  getAssetAuditReport(assetAuditReportId:any){
    this.generic_service.getAssetAuditReport(assetAuditReportId).subscribe(
      (response:any)=>{
        this.singleAssetAuditReportData = []
        this.singleAssetAuditReportData.push(response.response)
      }
    )
  }


  cancelModel(){
    document.getElementById("closeModalButton")?.click()
    document.getElementById("closeModalButton1")?.click()
    document.getElementById("closeModalButton2")?.click()
    document.getElementById("closeModalButton3")?.click()
  }

  deleteLocation(){
    this.job_portal_service.deleteLocation(this.id).subscribe(
      (response:any)=>{
        this.toastr.success(response.message)
        this.getAllAssetAuditReport();
        this.cancelModel();
        this.clearData()
      },
      (err:any)=>{
        this.toastr.error(err.errors[0].description)
      }
    )
  }

  deleteIdSelect(id:any,list: any){
    this.id = id
    this.recordId = list.locationId
    this.recordName = list.city
  }
  
  clearData(){
    this.recordId = "";
    this.recordName = "";
  }

  addLocation(){

    if(this.formSubmit){
      return
    }

    this.formSubmit = true;

    if(!this.assetAuditReportForm.valid){
      this.formSubmit = false;
      this.toastr.error("please fill required fields");
      return
    }

    let body = {

      "version": 0,
      "isActive": true,
      "description": "string",
      "financialYear": this.assetAuditReportForm.get('financialYear').value,
      "auditReportDocumentName": this.assetAuditReportForm.get('auditReportDocumentName').value,
      "auditReportDocumentPath": this.assetAuditReportForm.get('auditReportDocumentPath').value,
      "auditedByCompany":this.assetAuditReportForm.get('auditedByCompany').value,
      "auditReportSubmittedOn": new Date(),
      "cid": this.cid,
    }

    console.log(body)
    this.generic_service.addAssetAuditReport(body).subscribe(
      (response:any)=>{
        this.formSubmit = false;
        this.assetAuditReportForm.reset()
        this.cancelModel()
        this.getAllAssetAuditReport();
        this.file = ''
        this.fileName = ''
        this.toastr.success(response.message);
      },
      (err:any)=>{
        console.log(err)
        this.formSubmit = false;
        this.toastr.error(err.error.errors[0].description);
      }
    )
  }


  refreshAll(){
    this.pageNumber = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllAssetAuditReport()
  }


  getLocationByWildSearch(){
    console.log(this.searchFilter)
    if(this.searchFilter == "" || this.searchFilter == null){
      return
    }
    this.job_portal_service.getLocationByWildSearch(this.searchFilter).subscribe(
      (res: any) => {
        if(res.response == null || res.response.length == 0 || res.response == undefined){
          this.assetAuditReportList = []
          this.totalRecords = 0
          return

        }
        this.assetAuditReportList = res.response
        this.totalRecords = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }


  removeFile(fileInput: HTMLInputElement) {
    fileInput.value = '';
    this.file = ''
    this.fileName = ''
  
  }

  addFileBtn(){
    document.getElementById("add-btn")?.click()
  }

  onChange(event: any,fileInput: HTMLInputElement) {
    this.file = event.target.files[0];

    const validTypes = [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    ];

    if (!validTypes.includes(this.file.type)) {
      this.toastr.error('Only .pdf, .docx and .xlsx files are allowed.')

      this.removeFile(fileInput);
      return;
    }else{
      if (this.file.size <= 1 * 1024 * 1024) {

      } else {
        this.toastr.error('File size exceeds 1MB. Please select a smaller file.');

        this.removeFile(fileInput);
        return

      }
    }
    this.onUpload()
  }
  
  onUpload() {


    this.generic_service.uploadFile(this.file).subscribe(
      (event: any) => {
        console.log(event);
        console.log(this.file);
        this.fileName = this.file.name
        this.assetAuditReportForm.patchValue(
          {
            auditReportDocumentPath: event.response
          }
        );

    });

  }

}


